export const isKey = (event, key) => event && key && event.key === key;
export const isWidthTruncated = (event) =>
  event.target.offsetWidth &&
  event.target.scrollWidth &&
  event.target.offsetWidth < event.target.scrollWidth;
